import {Move} from "../../js/helpers";
import {break_xl} from "../../js/constants";

new Move(document.querySelector('[data-move="lk-settings-get"]'), document.querySelector('[data-move="lk-settings-set"]'), break_xl).init();